import React, { Component } from 'react'
import { Link } from 'gatsby'
import './Navigation.scss'
import sidenavDecoration from '../../../static/images/sidenav-multired.svg'

class CategoryNavigation extends Component {
  constructor(props) {
    super(props)
    this.state = { showNav: false }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.setState(prevState => ({
      showNav: !prevState.showNav,
    }))
  }

  render() {
    const { children, config } = this.props

    const sidebar = (
      <div
        className={
          this.state.showNav
            ? 'sidenav category show'
            : 'sidenav category hidden'
        }
        aria-hidden={this.state.showNav ? false : true}
      >
        <a
          role="button"
          aria-label="Category Navigation Trigger"
          aria-expanded={this.state.showNav ? true : false}
          href="#"
          className="closebtn category-close"
          onClick={ev => {
            ev.preventDefault()
            this.handleClick()
          }}
        >
          <span>{this.props.label}</span> &times;
        </a>
        <nav role="navigation" className="menu">
          <ul>
            {this.props.dropdownItems.map((item, index) => {
              let link = item.split(' ').join('-')
              return (
                <li key={index}>
                  <Link
                    key={index}
                    activeClassName="active"
                    to={`/blog/${link}`}
                    alt={item}
                  >
                    {item}
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>
        <div className="decoration-block">
          <img src={sidenavDecoration} />
        </div>
      </div>
    )

    return (
      <div>
        <a
          role="button"
          aria-label="Category Navigation Trigger"
          href="#"
          aria-expanded={this.state.showNav ? true : false}
          className="button primary category-trigger "
          onClick={ev => {
            ev.preventDefault()
            this.handleClick()
          }}
        >
          {this.props.label} <i className="fa fa-bars"></i>
        </a>
        {sidebar}
        <div
          className="main"
          style={this.state.showNav ? { marginRight: '250px' } : {}}
        >
          {children}
        </div>
      </div>
    )
  }
}

export default CategoryNavigation
